import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { TiHome } from "react-icons/ti";
import { IoPerson } from "react-icons/io5";
import { BsFileText, BsCardChecklist } from "react-icons/bs";
import { IoMdMenu } from "react-icons/io";
import { useDispatch } from "react-redux";
import { clearAuth } from "../Redux/authSlice";

const EspaceClient = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 840);
  const [menuOpen, setMenuOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 840);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const shortcuts = [
    { label: "Dashboard", icon: TiHome, path: "/EspaceClient" },
    { label: "Devis", icon: BsFileText, path: "/EspaceClient/devis" },
    { label: "Factures", icon: BsCardChecklist, path: "/EspaceClient/factures" },
    { label: "Profil", icon: IoPerson, path: "/EspaceClient/profil" },
  ];

  const navItems = [
    { label: "Clients", path: "/EspaceClient/clients" },
    { label: "Relance devis", path: "/EspaceClient/relances/devis" },
    { label: "Relance Facture", path: "/EspaceClient/relances/factures" },
    { label: "Avoirs", path: "/EspaceClient/avoirs" },
  ];

  const handleClick = (path) => {
    navigate(path);
    setMenuOpen(false);
  };


  const handleLogout = () => {
    dispatch(clearAuth());
    navigate("/login");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="lg:grid lg:grid-cols-[210px_1fr] w-full h-screen overflow-hidden">
      {/* Sidebar desktop */}
      {!isMobile && (
        <div className="h-screen w-60 z-20">
          <Sidebar />
        </div>
      )}

      {/* Main */}
      <div className="flex flex-col h-screen overflow-hidden w-full">
        {/* Top bar mobile */}
        {isMobile && (
          <header className="fixed top-0 left-0 w-full bg-color1 text-white flex justify-between items-center px-4  shadow-md z-50">
            {/* Logo */}
            <img
              src={require("../assets/logo.png")}
              alt="Logo"
              className="w-36 object-contain"
            />

            {/* Hamburger */}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-white text-2xl"
            >
              <IoMdMenu />
            </button>
          </header>
        )}

        {/* Mobile dropdown menu */}
        {isMobile && menuOpen && (
          <div className="lg:hidden bg-color1 w-full absolute top-14 left-0 z-40 transition-all duration-300">
            <ul className="flex flex-col items-center gap-4 py-6 text-color2">
              {navItems.map((item) => (
                <li
                  key={item.label}
                  className={`font-bold font-Poppins text-md hover:text-color3 cursor-pointer ${isActive(item.path) ? "text-color3" : ""
                    }`}
                  onClick={() => handleClick(item.path)}
                >
                  {item.label}
                </li>
              ))}
            </ul>

            <div className="flex flex-col items-center gap-3 mb-6">
              <button
                onClick={handleLogout}
                className="w-[180px] text-center font-bold font-Poppins text-md text-white bg-color1 border-[1px] rounded-lg px-3 py-2 hover:bg-red-100 transition"
              >
                Se déconnecter
              </button>
            </div>
          </div>
        )}

        {/* Main content */}
        <div
          className={`flex-1 overflow-auto lg:px-5 py-5 bg-white shadow-lg ${isMobile ? "mt-16 mb-14" : ""
            }`}
        >
          <Outlet />
        </div>

        {/* Bottom bar mobile */}
        {isMobile && (
          <div className="fixed bottom-0 left-0 w-full bg-color1 border-t border-gray-300 shadow-inner flex justify-around py-2 z-50">
            {shortcuts.map((item) => (
              <button
                key={item.label}
                onClick={() => handleClick(item.path)}
                className={`flex flex-col items-center text-xs ${isActive(item.path) ? "text-color3" : "text-color2"
                  }`}
              >
                <item.icon size={24} />
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EspaceClient;
